
import ActionsForm from '@/shared/mixins/actionsForm'
import FileEnterpriseRepository from '@/shared/http/repositories/realestate/fileenterprise'
import semImagem from '../../../../../../../static/img/survey/sem-foto.png'

export default {
  name: 'PanelPrice',
  mixins: [ActionsForm],
  props: ['selectedEnterprise'],
  data () {
    return {
      foto: '',
      semImagem: semImagem
    }
  },
  mounted () {
    this.getLogo()
  },
  methods: {
    getLogo () {
      FileEnterpriseRepository.GetLogoByEmpreendimentoId(this.selectedEnterprise.id)
        .then(Response => {
          this.foto = Response.data
          if (this.foto === null) {
            this.foto = this.semImagem
          }
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/pricetablemanagement/components/panelPrice/panelPrice.js